import { render, staticRenderFns } from "./customerEdit.vue?vue&type=template&id=71f4adf1&scoped=true&"
import script from "./customerEdit.vue?vue&type=script&lang=ts&"
export * from "./customerEdit.vue?vue&type=script&lang=ts&"
import style0 from "./customerEdit.vue?vue&type=style&index=0&id=71f4adf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f4adf1",
  null
  
)

export default component.exports